import React, { ReactNode } from 'react'

import { Profile } from 'common/enum/profile'
import { ReactComponent as DashboardIconOutline } from 'presentation/assets/icons/dashboard-outline.svg'
import { ReactComponent as PersonIconOutline } from 'presentation/assets/icons/person-outline.svg'
import { ReactComponent as PeopleIconOutline } from 'presentation/assets/icons/people-outline.svg'
import { ReactComponent as BriefcaseIconOutline } from 'presentation/assets/icons/briefcase-outline.svg'
import { ReactComponent as StethoscopeIconOutline } from 'presentation/assets/icons/stethoscope-outline.svg'
import { ReactComponent as FavoriteOutlineIcon } from 'presentation/assets/icons/star-outline.svg'
import { ReactComponent as ScheduleOutlineIcon } from 'presentation/assets/icons/calendar-outline.svg'
import { ReactComponent as SchedulingRequestsIcon } from 'presentation/assets/icons/scheduling-sector-icon.svg'
import { ReactComponent as ScheduledSurgeriesIcon } from 'presentation/assets/icons/calendar-icon.svg'
import { ReactComponent as CancelledScheduleSurgeryIcon } from 'presentation/assets/icons/cancelled-scheduled-surgery-icon.svg'
import { ReactComponent as ActiveSearchIcon } from 'presentation/assets/icons/active-search-icon.svg'
import { ReactComponent as TableRoundedIcon } from 'presentation/assets/icons/table-rounded.svg'
// import { ReactComponent as CalendarAddNewIcon } from 'presentation/assets/icons/calendar-add-new.svg'

export interface MenuItem {
  link: string
  label: string
  icon: ReactNode | string
  profiles: string[]
  isAddCollaboratorAdmin?: boolean
}

export const items: MenuItem[] = [
  {
    link: '/home',
    label: 'Dashboard',
    icon: <DashboardIconOutline />,
    profiles: [
      Profile.CRMO,
      Profile.HOSPITAL,
      Profile.SECRETARY,
      Profile.AMBULATORY,
      Profile.DOCTOR_REGISTER,
      Profile.DIRECTOR_DOCTOR_REGISTER
    ]
  },
  {
    link: '/pacientes',
    label: 'Pacientes',
    icon: <PersonIconOutline />,
    profiles: [Profile.HOSPITAL, Profile.CRMO]
  },
  {
    link: '/medicos',
    label: 'Médicos',
    icon: <StethoscopeIconOutline />,
    profiles: [Profile.HOSPITAL, Profile.CRMO]
  },
  {
    link: '/busca-ativa',
    label: 'Pesquisa',
    icon: <ActiveSearchIcon />,
    profiles: [Profile.HOSPITAL, Profile.CRMO]
  },
  {
    link: '/colaboradores',
    label: 'Colaboradores',
    icon: <BriefcaseIconOutline />,
    profiles: [Profile.HOSPITAL]
  },
  {
    link: '/colaboradores/save',
    label: 'Administradores',
    icon: <PeopleIconOutline />,
    profiles: [Profile.HOSPITAL],
    isAddCollaboratorAdmin: true
  },
  {
    link: '/favoritos',
    label: 'Meus Favoritos',
    icon: <FavoriteOutlineIcon />,
    profiles: [Profile.SECRETARY]
  },
  {
    link: '/pedidos',
    label: 'Pedidos',
    icon: <ScheduleOutlineIcon />,
    profiles: [Profile.SECRETARY]
  },
  {
    link: '/pronto-socorro',
    label: 'Pronto Socorro',
    icon: <DashboardIconOutline />,
    profiles: [Profile.EMERGENCY_ROOM]
  },
  {
    link: '/setor-de-marcacao/pedidos/todos',
    label: 'Todos os pedidos', // usar enum SurgicalOrderStatus (ou enum do setor de marcação)
    icon: <TableRoundedIcon />,
    profiles: [Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]
  },
  // Funcionalidade temporariamente desativada (aguardando validação do cliente)
  // {
  //   link: '/setor-de-marcacao/pedidos/criar-agendamento',
  //   label: 'Criar agendamento', // usar enum SurgicalOrderStatus (ou enum do setor de marcação)
  //   icon: <CalendarAddNewIcon />,
  //   profiles: [Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]
  // },
  {
    link: '/setor-de-marcacao/solicitacoes',
    label: 'Solicitações de Agendamento',
    icon: <SchedulingRequestsIcon />,
    profiles: [Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]
  },
  {
    link: '/setor-de-marcacao/cirurgias-agendadas',
    label: 'Cirurgias Agendadas',
    icon: <ScheduledSurgeriesIcon />,
    profiles: [Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]
  },
  {
    link: '/setor-de-marcacao/agendamentos-cancelados',
    label: 'Agendamentos Cancelados',
    icon: <CancelledScheduleSurgeryIcon />,
    profiles: [Profile.SETOR_DE_MARCACAO, Profile.HOSPITAL]
  }
]
